export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const BACKGROUND_FILTER_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 640,
  height: 480,
  frameRate: 24,
};

/* Changing the word Sendinblue in these below keys would mean that the users would lose all their settings once we deploy it.
  TODO: Decide if we want to change it or not. */
// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = 'Sendinblue-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'Sendinblue-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'Sendinblue-selectedVideoInput';
export const SELECTED_VIDEO_LABEL_KEY = 'Sendinblue-selectedVideoLabel';

// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY = 'Sendinblue-selectedBackgroundSettings';

export const GALLERY_VIEW_ASPECT_RATIO = 9 / 16; // 16:9
export const GALLERY_VIEW_MARGIN = 3;

// FullStory domain mapping configuration
export const FULLSTORY_DOMAIN_MAPPING = {
  FROM: 'app.fsrelay.brevo.com',
  TO: 'app.fullstory.com',
};
